import SubBanner from "../../comm/SubBanner";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { LoginAccount } from "../../../js/server";

function Login(props) {
    const dispatch = useDispatch();
    const useridInput = useRef();
    const [userid, setUserid] = useState(null);
    const [userpw, setUserpw] = useState(null);

    const fnLoginClick = () => {
        if (userid && userpw) {
            dispatch({ type: "loadingChange", payload: true });

            LoginAccount(userid, userpw)
                .then((res) => {
                    if (res.data.result === "OK") {
                        dispatch({ type: "authUpdate", payload: res.data.jsonData });
                        localStorage.setItem(
                            "userinfo",
                            JSON.stringify(res.data.jsonData)
                        );

                        if (!props.aPage) {
                            window.location.href = "/";
                        }
                    } else {
                        alert(res.data.msg);
                        document.getElementById("inputUserid").value = null;
                        document.getElementById("inputPassword").value = null;
                        document.getElementById("inputUserid").focus();
                        setUserid(null);
                        setUserpw(null);
                        dispatch({ type: "authUpdate", payload: null });
                        localStorage.removeItem("userinfo");
                    }
                })
                .catch((err) => {
                    console.error(err);
                    dispatch({ type: "authUpdate", payload: null });
                    localStorage.removeItem("userinfo");
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        } else {
            alert("아이디와 비밀번호를 입력해 주세요.");
            document.getElementById("inputUserid").focus();
        }
    };

    const fnEnterCheck = (e) => {
        if (e.key === "Enter") {
            fnLoginClick();
        }
    };

    useEffect(() => {
        dispatch({
            type: "pageChange",
            payload: { sub01: "회원관리", sub02: "로그인" },
        });
        dispatch({ type: "authUpdate", payload: null });
        dispatch({ type: "loadingChange", payload: true });

        setTimeout(() => {
            localStorage.removeItem("userinfo");

            useridInput.current.focus();
            dispatch({ type: "loadingChange", payload: false });
        }, 500);
    }, [dispatch]);

    return (
        <>
            <SubBanner id="member" aPage="" />

            <section className="appoinment section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-2"></div>

                        <div className="col-lg-6 col-md-8">
                            <div className="row">
                                <div className="col-lg-12">
                                    <p>
                                        로그인시 조합원 전용메뉴를 이용하실 수 있으며
                                        <br />
                                        비회원은 회원가입을 통해 조합가입 신청을 해주세요.
                                    </p>
                                </div>
                            </div>

                            <div className="row round-box">
                                <div className="col-lg-12">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-control-label">아이디</label>
                                                <input
                                                    id="inputUserid"
                                                    name="inputUserid"
                                                    type="text"
                                                    className="form-control"
                                                    ref={useridInput}
                                                    onChange={(e) => setUserid(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label className="form-control-label">비밀번호</label>
                                                <input
                                                    id="inputPassword"
                                                    name="inputPassword"
                                                    type="password"
                                                    className="form-control"
                                                    onChange={(e) => setUserpw(e.target.value)}
                                                    onKeyDown={fnEnterCheck}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-lg-6 col-md-12">
                                            <Link to="/JoinStep01">
                                                <span className="mr-3">회원가입</span>
                                            </Link>
                                            <Link to="/FindAccount">
                                                <span className="mr-3">아이디/비밀번호 찾기</span>
                                            </Link>
                                        </div>

                                        <div className="col-lg-6 col-md-12 text-right">
                                            <span
                                                className="btn btn-main-2 btn-icon btn-round-full"
                                                onClick={fnLoginClick}
                                            >
                                                로그인
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-2"></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Login;
